// extracted by mini-css-extract-plugin
var _1 = "buttons__mxU5E";
var _2 = "header__wbyYy";
var _3 = "modal__hWWYx";
var _4 = "modal--fullscreen__wiJZI";
var _5 = "only-close__uXHNV";
var _6 = "subheader__QVT9Z";
export { _1 as "buttons", _2 as "header", _3 as "modal", _4 as "modal--fullscreen", _5 as "only-close", _6 as "subheader" }
